const VERDICT_LABELS = {
  PASS: "Conforme",
  REVIEW: "À vérifier",
  FAIL: "Non conforme",
};

const FIELD_LABELS = {
  productFullyVisible: "Produit entièrement visible",
  damagesVisible: "Dommages visibles",
  coherenceWithDeclaration: "Cohérence avec la déclaration",
};

export function verdictLabel(verdict) {
  return VERDICT_LABELS[verdict] || verdict || "—";
}

export function badgeClassFor(verdict) {
  switch (verdict) {
    case "PASS":
      return "bg-green-100 text-green-800";
    case "REVIEW":
      return "bg-yellow-100 text-yellow-800";
    case "FAIL":
      return "bg-red-100 text-red-800";
    default:
      return "bg-gray-100 text-gray-700";
  }
}

export function mapChecks(analysis) {
  const rawChecks = analysis?.checks;
  if (!rawChecks) return [];
  return Object.entries(rawChecks).map(([field, data]) => ({
    field,
    label: FIELD_LABELS[field] || field,
    verdict: data?.verdict,
    reason: data?.reason,
  }));
}

export function formatAnalyzedAt(analyzedAt) {
  if (!analyzedAt) return "";
  return new Date(analyzedAt).toLocaleString("fr-FR");
}
